/**
 * Application entry point.
 *
 * This file includes `import`'s for all the components/directives used
 * by the HTML page and the controller to provide the configuration.
 */

import './sass/iframe_api.scss';

import angular from 'angular';
import gmfControllersAbstractAPIController, {
  AbstractAPIController,
} from 'gmf/controllers/AbstractAPIController';
import sitnBase from '../index';

if (!window.requestAnimationFrame) {
  alert(
    'Your browser is not supported, please update it or use another one. You will be redirected.\n\n' +
      "Votre navigateur n'est pas supporté, veuillez le mettre à jour ou en utiliser un autre. " +
      'Vous allez être redirigé.\n\n' +
      'Ihr Browser wird nicht unterstützt, bitte aktualisieren Sie ihn oder verwenden Sie einen anderen. ' +
      'Sie werden weitergeleitet.',
  );
  window.location.href = 'https://geomapfish.org/';
}

/**
 * @private
 */
class Controller extends AbstractAPIController {
  /**
   * @param {angular.IScope} $scope Scope.
   * @param {angular.auto.IInjectorService} $injector Main injector.
   * @export
   */
  constructor($scope, $injector) {
    super($scope, $injector);
    window['sitnExterns'] = {};
    window['sitnExterns']['openWindow'] = this.sitnDisplayWindow.bind(this);
    window['sitnExterns']['openPanel'] = this.sitnOpenPanel.bind(this);
    window['sitnExterns']['openTab'] = this.sitnOpenTab.bind(this);
    window['sitnExterns']['openUrl'] = this.sitnOpenUrl.bind(this);
    window['sitnExterns']['sitn_document_url'] = $injector.get('sitnDocumentUrl');
    window['sitnExterns']['sitn_lubis_url'] = $injector.get('sitnLubisUrl');
    window['sitnExterns']['sitn_orthophoto_url'] = $injector.get('sitnOrthophotoUrl');
    window['sitnExterns']['sitn_servitudes_url'] = $injector.get('sitnServitudesUrl');
    window['sitnExterns']['sitn_sau_list_url'] = $injector.get('sitnSauUrl');
    window['sitnExterns']['sitn_ouvrage_protection_url'] = $injector.get('sitnOuvrageProtectionUrl');
    window['sitnExterns']['sitn_ag_doc_list_url'] = $injector.get('sitnAgDocListUrl');
  }

  /**
   * @param {string} title Title.
   * @param {string} url Url.
   * @param {number} width Width.
   * @param {number} height Height.
   */
  sitnDisplayWindow(title, url, width, height) {
    if (url in window['sitnExterns']) {
      url = window['sitnExterns'][base_url];
    }
    const win = window.open(url, '_blank');
    if (win) {
      win.focus();
    } else {
      alert("Merci d'autoriser l'ouverture d'onglets supplémentaires");
    }
  }

  /**
   * @param {string} moduleName The name of the target module.
   * @param {string} data Data to bind to module.
   */
  sitnOpenPanel(moduleName, data) {
    console.error('moduleName', moduleName);
    console.error('data', data);
    alert("Cette fonctionnalité n'est pas encore supportée. Merci de contacter le SITN");
  }

  /**
   * @param {string} base_url url
   * @param {string} param_string params
   */
  sitnOpenTab(base_url, param_string) {
    let url;

    if (base_url in window['sitnExterns']) {
      url = window['sitnExterns'][base_url];
    } else {
      url = base_url;
    }
    if (param_string && param_string !== '') {
      url += '?' + param_string;
    }
    const win = window.open(url, '_blank');
    if (win) {
      win.focus();
    } else {
      alert("Merci d'autoriser l'ouverture de fenêtres supplémentaires");
    }
  }

  /**
   * @param {string} base_url url
   * @param {string} suffix params
   * @param {string} param_string params
   */
  sitnOpenUrl(base_url, suffix, param_string) {
    let url;

    if (base_url in window['sitnExterns']) {
      url = window['sitnExterns'][base_url];
    } else {
      url = base_url;
    }
    if (suffix) {
      url += '/' + suffix;
    }
    if (param_string) {
      url += '?' + param_string;
    }
    const win = window.open(url, '_blank');
    if (win) {
      win.focus();
    } else {
      alert("Merci d'autoriser l'ouverture d'onglets supplémentaires");
    }
  }
}

Controller.$inject = ['$scope', '$injector'];

/**
 * @hidden
 */
const sitnModule = angular.module('Appiframe_api', [
  sitnBase.module.name,
  gmfControllersAbstractAPIController.name,
]);

sitnModule.controller('IframeAPIController', Controller);

export default sitnModule;
